import { Calendar } from 'pepsico-ds';
import React from 'react';
import "./CustomCalendar.css"

const CustomCalendar = ({ eventCategories, events }) => {

  return (
    <Calendar
      eventCategories={eventCategories}
      events={events}
      maxEventsInView={5}
    />
  );
};

export default CustomCalendar;
